import * as React from "react";
import { gql, useMutation, MutationHookOptions, MutationTuple } from "@apollo/client";
import {
  NewMerchantApprovalMutation,
  NewMerchantApprovalMutationVariables
} from "../../../../schemaTypes";

export const newMerchantApprovalMutation = gql`
  mutation NewMerchantApproval(
    $merchantId: String!
  ) {
    newMerchantApproval(
      merchantId: $merchantId
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

export interface WithNewMerchantApproval {
  newMerchantApproval: MutationTuple<
    NewMerchantApprovalMutation, 
    NewMerchantApprovalMutationVariables
  >[0];
}


interface NewMerchantApprovalProps {
  children: (data: WithNewMerchantApproval) => React.ReactElement | null;
  options?: MutationHookOptions<
    NewMerchantApprovalMutation, 
    NewMerchantApprovalMutationVariables
  >;
}

export const NewMerchantApproval: React.FC<NewMerchantApprovalProps> = ({ children, options }) => {
  const [newMerchantApproval] = useMutation<
    NewMerchantApprovalMutation, 
    NewMerchantApprovalMutationVariables
  >(
    newMerchantApprovalMutation,
    options
  );
  return children({ newMerchantApproval });
};